<div class="form-row">
  <label>
    {{ Yii.t('app', 'Enable Due Time') }}
  </label>
  <div>
    <p-checkbox binary="true" [(ngModel)]="ssvc.settings.schedule.enable_due_time" type="checkbox" (change)="ssvc.clearDueTimeValue()"/>
  </div>
</div>
@if (ssvc.settings.schedule.enable_due_time) {
  <div class="form-row flex-align-center">
    <label>
      {{ Yii.t('app', 'Due Time') }}
    </label>
    <div class="flex-col gap-8px">
      <div>
        <p-button
          icon="fa fa-plus"
          size="small"
          [label]="Yii.t('app', 'Add')"
          (click)="ssvc.AddNewDueTime()"
        />
      </div>
      @for (dueTimeValue of ssvc.settings.due_times; track dueTimeValue.id; let i = $index) {
        <ng-due-time-item
          [(value)]="dueTimeValue.due_time"
          (onDelete)="ssvc.deleteDueTime(i)"
        />
      }
    </div>
  </div>
}
